import { render, staticRenderFns } from "./reward-header.vue?vue&type=template&id=39014109&scoped=true&"
import script from "./reward-header.vue?vue&type=script&setup=true&lang=ts&"
export * from "./reward-header.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./reward-header.vue?vue&type=style&index=0&id=39014109&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39014109",
  null
  
)

export default component.exports